// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header .rect2 {
  width: 3px;
  height: calc(16 * var(--width-ratio));
  background: var(--ion-color-primary-tint);
  border-radius: 10px;
  margin-right: 5px;
}

.related-item {
  margin-top: 10px;
}
.related-item .slot1 ion-avatar {
  width: calc(60 * var(--width-ratio));
  height: calc(60 * var(--width-ratio));
  border: 1px;
  border-color: var(--ion-color-primary-tint);
  border-style: solid;
}
.related-item .slot2 {
  padding-left: calc(10 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/related-pgc-post/related-pgc-post.component.scss"],"names":[],"mappings":"AACE;EACE,UAAA;EACA,qCAAA;EACA,yCAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;AAII;EACE,oCAAA;EACA,qCAAA;EACA,WAAA;EACA,2CAAA;EACA,mBAAA;AAFN;AAME;EACE,2CAAA;AAJJ","sourcesContent":[".header {\n  .rect2 {\n    width: 3px;\n    height: calc(16 * var(--width-ratio));\n    background: var(--ion-color-primary-tint);\n    border-radius: 10px;\n    margin-right: 5px;\n  }\n}\n\n.related-item {\n  margin-top: 10px;\n\n  .slot1 {\n    ion-avatar {\n      width: calc(60 * var(--width-ratio));\n      height: calc(60 * var(--width-ratio));\n      border: 1px;\n      border-color: var(--ion-color-primary-tint);\n      border-style: solid;\n    }\n  }\n\n  .slot2 {\n    padding-left: calc(10 * var(--width-ratio));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
